import { useBlockProps, RichText } from '@wordpress/block-editor';

export default function save(props) {
	const blockProps = useBlockProps.save({
		className: 'c4l-reading-context',
	});

	const { attributes } = props;
	const { text, caption } = attributes;

	return (
		<div {...blockProps}>
			<div className='c4l-reading-context-content'>
				<RichText.Content
					tagName='div'
					className='c4l-reading-context-text'
					value={text}
				/>
				<RichText.Content
					tagName='div'
					className='c4l-reading-context-caption'
					value={caption}
				/>
			</div>
		</div>
	);
}
